import React from 'react';

/**
 * Barra de navegación inferior: Mapa / Retornar / Reportar (FAB) / Seguimiento
 * (README 5.1). "Retornar" vuelve al inicio (splash). El FAB "Registrar" lleva
 * un pulso suave para llamar la atención (HU-027).
 */
const BottomNav = ({ onMapa, onReportar, onSeguimiento, onInicio, activo = 'mapa' }) => {
  return (
    <nav className="mp-bottom-nav">
      <button
        type="button"
        className={`mp-nav-item ${activo === 'mapa' ? 'mp-nav-activo' : ''}`}
        onClick={onMapa}
      >
        <i className="fas fa-map-marked-alt"></i>
        <span>Mapa</span>
      </button>

      <button type="button" className="mp-nav-item" onClick={onInicio} title="Volver al inicio">
        <i className="fas fa-house"></i>
        <span>Retornar</span>
      </button>

      <button
        type="button"
        className="mp-nav-fab"
        onClick={onReportar}
        title="Registrar incidencia"
      >
        <i className="fas fa-plus"></i>
        <span className="mp-nav-fab-label">Registrar</span>
      </button>

      <button
        type="button"
        className={`mp-nav-item ${activo === 'seguimiento' ? 'mp-nav-activo' : ''}`}
        onClick={onSeguimiento}
        title="Seguimiento"
      >
        <i className="fas fa-ticket-alt"></i>
        <span>Seguimiento</span>
      </button>
    </nav>
  );
};

export default BottomNav;
